import { addRasterOverlay, removeRasterOverlay } from '../raster_helpers';
import { sanityCheckSourceUrl } from '../admin_customization_helpers';

const adminOverlayId = 'admin-overlay';

const addAdminOverlay = (map, adminCustomizationSettings) => {
  if (!sanityCheckSourceUrl(adminCustomizationSettings.overlaySourceUrl)) {
    return;
  }
  addRasterOverlay(
    map,
    adminOverlayId,
    adminCustomizationSettings.overlaySourceUrl,
    { tileSize: 256 },
    {
      paint: {
        'raster-opacity': 0.5
      }
    }
  );
};

const removeAdminOverlay= map => {
  removeRasterOverlay(map, adminOverlayId);
};

export { addAdminOverlay, removeAdminOverlay };
